import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';

import { AuthHttpClient } from '../../../../providers/auth-http.service';

import { default as swal } from 'sweetalert2';


export class SharedThirdPartyIntegrationService {

	public baseUrl: string = '/v1/third-party-integration';
	public baseUrlV3: string = '/v3/ats';

	constructor(protected sHttp: AuthHttpClient) {}

	public get(userId: string): Observable<any> {
		let url = this.baseUrl + '/auth/client/' + userId + '/third-party-integrations';
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getAtsIntegrationsV3(): Observable<any> {
		let url = this.baseUrlV3 + '/auth/client/integrations';
		return this.sHttp.get(url)
			.map(this.extractDataV3)
			.catch(this.handleError);
	}

	public connectAtsIntegrationV3(body: any): Observable<void> {
		let url = this.baseUrlV3 + '/auth/client/connection';
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public initAtsIntegrationKomboV3(identifier: string): Observable<any> {
		let url = this.baseUrlV3 + '/auth/client/kombo/' + identifier;
		return this.sHttp.post(url, '')
			.map(this.extractDataV3)
			.catch(this.handleError);
	}

	public activateAtsIntegrationKomboV3(identifier: string, body: any): Observable<void> {
		let url = this.baseUrlV3 + '/auth/client/kombo/' + identifier + '/activated';
		return this.sHttp.put(url, body)
			.catch(this.handleError);
	}

	public editIntegrationSyncType(configType: string): Observable<any> {
		let url = this.baseUrlV3 + '/auth/client/connection/sync_type';
		return this.sHttp.patch(url, JSON.stringify({value: configType}))
			.catch(this.handleError);
	}

	public deleteEntity(userId: string, identifier: string): Observable<void> {
		let url = this.baseUrl + '/auth/client/' + userId + '/third-party-integration/' + identifier;
		return this.sHttp.delete(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public deleteAtsIntegrationsV3(): Observable<any> {
		let url = this.baseUrlV3 + '/auth/client/connection/enabled';
		return this.sHttp.patch(url, JSON.stringify({enabled: false}))
			.catch(this.handleError);
	}

	public disableAtsIntegrationsV1(): Observable<any> {
		let url = this.baseUrlV3 + '/auth/client/connection/disabled';
		return this.sHttp.patch(url, JSON.stringify({}))
		.catch(this.handleError);
	}

	public getMappedCandidatesCountByIntegration(atsIdentifier: string): Observable<any> {
		let url = `${this.baseUrlV3}/auth/client/mapped_candidates/${atsIdentifier}/count`;
		return this.sHttp.get(url).map(this.extractDataV3);
	}

	public postAccessCredentials(userId: string, identifier: string, data: any): Observable<any> {
		let url = this.baseUrl + '/auth/client/' + userId + '/third-party-integration/' + identifier + '/access-credentials';
		let body = JSON.stringify(data);
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch((res) => {
				if (res.status === 401 || res.status === 404) {
					return Observable.throw(res.status);
				}

				return this.handleError(res);
			});
	}

	public handleError(error: any) {
		let errTitle = `Oops, there's been an error`;
		let errContent = `Our tech team has been notified, however please email contact@hackajob.co and we'll try and solve the issue as soon as possible. Thanks and sorry for any inconvenience.`;
		let errMsg = (error.message) ? error.message :
		error.status ? `${error.status} - ${error.statusText}` : 'Server error';

		if (error.status === 403) {
			errContent = 'Something went wrong with your ATS account authentication. Please try to connect again from Account Settings page.';
		}

		if (error.status === 409) {
			errContent = 'There is already an identical jop mapping for your account!';
		}

		swal({
			title: errTitle,
			text: errContent,
			type: 'error',
			showCancelButton: false,
			confirmButtonColor: '#008fb3',
			confirmButtonText: 'Ok',
			allowOutsideClick: false,
			allowEscapeKey: false
		});
		return Observable.throw(errMsg);
	}

	private extractData(res: Response) {
		if (res) {
			let resp: any = res;
			if (res.status === 401) {
				window.location.assign(process.env.LANDING_PAGES_URL + '/talent/login');
			}
			if (resp._body && resp._body !== '') {
				let body = res.json();
				if (typeof Object.keys(body)[0] !== 'undefined') {
					return body[Object.keys(body)[0]];
				}
			}
			return {};
		}
	}

	private extractDataV3(res: Response) {
		if (res) {
			if (res.status === 401) {
				window.location.assign(process.env.LANDING_PAGES_URL + '/talent/login');
			}

			return res.json();
		}
	}
static ctorParameters() { return [ { type: AuthHttpClient } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/services/shared-third-party-integration.service.ts